<script>
import { Line, mixins } from 'vue-chartjs'
import 'chartjs-plugin-datalabels'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  created(){
    this.$moment.locale('pt-BR');
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
